import {
  FIELD_TYPES,
  INSTITUTIONS_FIELD,
  SEND_MODE_FIELDS,
  normalizeInstitutions,
  toBool,
} from '../Interfaces.shared';

export const RIS_INTERFACE_TYPES = {
  hl7: {
    id: 'hl7',
    titleKey: 'Settings.hl7_servers',
    dialogTitleKey: 'Settings.hl7_server_config',
    dialogSubtitleKey: 'Settings.hl7_server_config_subtitle',
    typeLabel: 'HL7',
    showTypeInTitle: true,
    endpoint: 'hl7_servers',
    emptyNode: {
      name: '',
      ip: '',
      port: '',
      tls: 0,
      institutions: [],
      send_automatic: 0,
      send_manual: 1,
    },
    fields: [
      { key: 'name', labelKey: 'Settings.name', type: FIELD_TYPES.TEXT, required: true },
      ...SEND_MODE_FIELDS,
      { key: 'ip', labelKey: 'Settings.ip', type: FIELD_TYPES.TEXT, required: true },
      { key: 'port', labelKey: 'Settings.port', type: FIELD_TYPES.NUMBER, required: true },
      {
        key: 'tls',
        labelKey: 'Settings.tls',
        type: FIELD_TYPES.BOOLEAN,
        required: false,
        display: 'activeState',
      },
      INSTITUTIONS_FIELD,
    ],
    headerToggles: ['send_automatic', 'send_manual'],
    displayFields: ['name', 'ip', 'port', 'tls', 'institutions'],
    hasPingTest: true,
    pingEndpoint: (name) => `ping_hl7_server/${name}`,
    normalize: (s) => ({
      name: s.Name || s.name || '',
      ip: s.IP || s.ip || '',
      port: s.Port || s.port || '',
      tls: s.TLS !== undefined ? toBool(s.TLS, false) : toBool(s.tls, false),
      send_automatic:
        s.send_automatic !== undefined ? s.send_automatic : s.SendDirect !== undefined ? s.SendDirect : 1,
      send_manual:
        s.send_manual !== undefined ? s.send_manual : s.SendManual !== undefined ? s.SendManual : 1,
      institutions: normalizeInstitutions(s.institutions),
    }),
  },
  fhir: {
    id: 'fhir',
    titleKey: 'Settings.fhir_servers',
    dialogTitleKey: 'Settings.fhir_server_config',
    dialogSubtitleKey: 'Settings.fhir_server_config_subtitle',
    typeLabel: 'FHIR',
    showTypeInTitle: true,
    endpoint: 'fhir_servers',
    emptyNode: {
      name: '',
      url: '',
      token: '',
      institutions: [],
      send_automatic: 0,
      send_manual: 1,
    },
    fields: [
      { key: 'name', labelKey: 'Settings.name', type: FIELD_TYPES.TEXT, required: true },
      ...SEND_MODE_FIELDS,
      { key: 'url', labelKey: 'Settings.url', type: FIELD_TYPES.TEXT, required: true },
      { key: 'token', labelKey: 'Settings.token', type: FIELD_TYPES.TEXT, required: false, display: 'masked' },
      INSTITUTIONS_FIELD,
    ],
    headerToggles: ['send_automatic', 'send_manual'],
    displayFields: ['name', 'url', 'token', 'institutions'],
    hasPingTest: true,
    pingEndpoint: (name) => `ping_fhir_server/${name}`,
    normalize: (s) => ({
      name: s.Name || s.name || '',
      url: s.URL || s.url || '',
      token: s.AuthToken || s.token || s.authToken || '',
      send_automatic:
        s.send_automatic !== undefined ? s.send_automatic : s.SendDirect !== undefined ? s.SendDirect : 1,
      send_manual:
        s.send_manual !== undefined ? s.send_manual : s.SendManual !== undefined ? s.SendManual : 1,
      institutions: normalizeInstitutions(s.institutions),
    }),
  },
};

export const RIS_COLLECTIONS = [
  {
    id: 'ris_merged',
    titleKey: 'Settings.hl7_and_fhir_servers',
    typeIds: ['hl7', 'fhir'],
    defaultTypeId: 'hl7',
    allowTypeSelection: true,
    showType: true,
    emptyMessageKey: 'Settings.no_ris_merged_servers_found',
  },
];
